
import { defineComponent } from "vue";
import EquipmentSummaryItem from "@/views/admin/EquipmentSummaryItem.vue";

export default defineComponent({
  name: "EquipmentSummary",
  components: {EquipmentSummaryItem},
  props: ["equipment"],
});
